/*
  be-product-form.js: Best Engravings additions to Dawn's product form (loaded by sections/main-product).

  Per main-product section (<section data-be-product data-section="...">):
  - Live CTA total: keeps <span class="be-atc__total"> inside #ProductSubmitButton-{id} at
    variant price x quantity (quantity input events, pubsub quantity-update and variant-change),
    and restores the custom button label (data-be-label) after Dawn's variant change resets it.
  - Metal switcher (be_metal_switcher block): rewrites each swatch href with
    BEEngraving.buildUrl(baseUrl, state) on engraving:change so the typed text survives the switch.
  - Metal variant option ("Metal" radios): label, engraving previews and the sheet follow the choice.
  - Gallery dots under the preview slide (mobile) and keeps the preview slide first after a
    variant change moves a variant image to the front.
  - Review link: smooth-scrolls to the Judge.me widget, with a class-based fallback target.

  Page-wide (one capture-phase submit listener on document, runs before Dawn's own handler):
  - Personalize sheet (mockup 3a, snippets/be-personalize-sheet.liquid): on phones, while the
    engraving is not done yet, the submit only opens the sheet (<be-personalize-sheet>.interceptSubmit()).
  - ?replace=<cart line key> (PERSONALIZER-CONTRACT 4): shows a notice above the buy box; on the
    first add, POSTs /cart/change.js {id: key, quantity: 0}, clears the param from the URL, then
    lets the normal add run. A failed change still adds. ?qty=N (sent with replace) restores the
    edited line's quantity in #Quantity-{id}, clamped to its min / max / step.
  - Required engraving (opt-in): only when the section's <engraving-personalizer> has
    data-enforce-required="true" must personalizer.validate() pass, or the add is blocked with a
    visible message. No template sets it yet, so nothing is blocked today (Dawn's form is novalidate).

  Why a capture listener and not a ProductForm.prototype.onSubmitHandler wrap: Dawn binds
  onSubmitHandler in the constructor, so product-form elements that upgraded before this file ran
  would keep the unwrapped method.
*/
(function () {
  if (window.BEProductForm) return;

  var MSG_FRONT_REQUIRED = 'Please type your engraving before adding it to your bag.';
  var NOTICE_TEXT = 'Editing the {noun} in your bag. Adding it again replaces the old one.';

  // ---------------------------------------------------------------- money
  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = String(format || '${{amount}}').replace(/<[^>]*>/g, '');
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return '$' + (cents / 100).toFixed(2);
    var whole = cents % 100 === 0;

    function fmt(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      var units = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? units + decimal + parts[1] : units;
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = fmt(0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = fmt(whole ? 0 : 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = fmt(0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = fmt(whole ? 0 : 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = fmt(0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        value = fmt(whole ? 0 : 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = fmt(whole ? 0 : 2, ' ', '.');
        break;
      default:
        value = fmt(whole ? 0 : 2, ',', '.');
    }
    return format.replace(match[0], value);
  }

  // pubsub.js / constants.js declare subscribe() and a top-level const PUB_SUB_EVENTS
  // (a lexical global, not a window property), so reference them by name.
  function sub(name, callback) {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS[name], callback);
    return true;
  }

  // ------------------------------------------------------ replace param
  function readReplace() {
    var BE = window.BEEngraving;
    if (BE && typeof BE.readParams === 'function') {
      try {
        return BE.readParams().replace || '';
      } catch (e) {
        /* fall through */
      }
    }
    try {
      return new URLSearchParams(window.location.search).get('replace') || '';
    } catch (e) {
      return '';
    }
  }

  var replaceState = { key: '', done: false, busy: false, qty: 0 };

  // ?qty=N (sent with ?replace= by the cart "Edit engraving" link): the quantity of the line being edited.
  function readQty() {
    try {
      var n = parseInt(new URLSearchParams(window.location.search).get('qty'), 10);
      return n > 0 ? n : 0;
    } catch (e) {
      return 0;
    }
  }

  // Put the edited line's quantity back into the stepper, clamped to its min / max / step.
  function applyQty(sectionId) {
    if (!replaceState.qty) return;
    var input = document.getElementById('Quantity-' + sectionId);
    if (!input) return;
    var min = parseInt(input.min, 10);
    var max = parseInt(input.max, 10);
    var step = parseInt(input.step, 10);
    if (!(min > 0)) min = 1;
    if (!(step > 0)) step = 1;
    var q = replaceState.qty;
    if (max > 0 && q > max) q = max;
    if (q < min) q = min;
    q = min + Math.floor((q - min) / step) * step;
    if (String(q) === input.value) return;
    input.value = q;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function clearReplaceParam() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('replace') && !url.searchParams.has('qty')) return;
      url.searchParams.delete('replace');
      url.searchParams.delete('qty');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (e) {
      /* old browsers keep the param; harmless */
    }
  }

  function showNotice(section) {
    var sectionId = section.dataset.section;
    var info = document.getElementById('ProductInfo-' + sectionId);
    if (!info || info.querySelector('.be-edit-notice')) return;
    var p = document.createElement('p');
    p.className = 'be-edit-notice';
    p.setAttribute('role', 'status');
    p.textContent = NOTICE_TEXT.replace('{noun}', section.dataset.beEditNoun || 'item');
    info.insertBefore(p, info.firstChild);
  }

  function removeNotices() {
    document.querySelectorAll('.be-edit-notice').forEach(function (n) {
      n.remove();
    });
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.classList.toggle('loading', busy);
    if (busy) btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !busy);
  }

  function removeCartLine(key) {
    var base = (window.routes && window.routes.cart_change_url) || '/cart/change';
    return fetch(base + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function (res) {
      if (!res.ok) throw new Error('cart/change ' + res.status);
      return res.json();
    });
  }

  // Capture phase on document: runs before Dawn's submit listener on the form itself.
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      // getAttribute, not form.id: the product form has an <input name="id"> (the variant), and a
      // named control shadows the form's own id property.
      var formId = form && form.getAttribute ? form.getAttribute('id') || '' : '';
      if (formId.indexOf('product-form-') !== 0) return;
      if (formId.indexOf('product-form-installment') === 0) return;
      var productForm = form.closest('product-form');
      if (!productForm) return;

      // Our own re-dispatch after the replace step: let Dawn handle it.
      if (form._beBypass) {
        form._beBypass = false;
        return;
      }

      var sectionId = productForm.dataset.sectionId || formId.replace('product-form-', '');
      var btn = productForm.submitButton || form.querySelector('[type="submit"]');

      if (replaceState.busy) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        return;
      }

      // Mockup 3a (phones): until the Personalize sheet is done, "Personalize & add" opens the sheet.
      var sheet = document.querySelector('be-personalize-sheet[data-section="' + sectionId + '"]');
      if (sheet && typeof sheet.interceptSubmit === 'function' && sheet.interceptSubmit()) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        return;
      }

      // Required engraving: opt-in per personalizer (data-enforce-required="true"). No template sets it
      // today, so classic templates keep their old behaviour (Dawn's form is novalidate, nothing blocks).
      var personalizer = document.querySelector('engraving-personalizer[data-section="' + sectionId + '"]');
      if (
        personalizer &&
        personalizer.dataset.enforceRequired === 'true' &&
        typeof personalizer.validate === 'function' &&
        !personalizer.validate()
      ) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if (typeof productForm.handleErrorMessage === 'function') {
          productForm.handleErrorMessage(personalizer.dataset.requiredMessage || MSG_FRONT_REQUIRED);
        }
        return;
      }

      if (!replaceState.key || replaceState.done) return;
      // Dawn ignores submits while its button is busy; do the same.
      if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();
      replaceState.busy = true;
      setBusy(btn, true);

      removeCartLine(replaceState.key)
        .catch(function () {
          /* the old line may already be gone; add the new one anyway */
        })
        .then(function () {
          replaceState.done = true;
          replaceState.busy = false;
          clearReplaceParam();
          removeNotices();
          setBusy(btn, false);
          form._beBypass = true;
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
    },
    true
  );

  // --------------------------------------------------------- CTA total
  function setupTotal(sectionId) {
    var btn = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!btn) return;
    var total = btn.querySelector('.be-atc__total');
    var qty = document.getElementById('Quantity-' + sectionId);
    var price = total ? parseInt(total.dataset.price, 10) || 0 : 0;
    var format = total ? total.dataset.moneyFormat : '';

    function update() {
      if (!total) return;
      var q = qty ? parseInt(qty.value, 10) : 1;
      if (!(q > 0)) q = 1;
      var text = formatMoney(price * q, format);
      if (total.textContent !== text) total.textContent = text;
    }

    function restoreLabel() {
      var label = btn.dataset.beLabel;
      var span = btn.querySelector(':scope > span');
      if (!label || !span || btn.disabled) return;
      if (span.textContent !== label) span.textContent = label;
    }

    if (qty) {
      qty.addEventListener('input', update);
      qty.addEventListener('change', update);
    }

    sub('quantityUpdate', update);
    sub('variantChange', function (event) {
      var data = event && event.data;
      if (!data || data.sectionId !== sectionId) return;
      if (data.variant && typeof data.variant.price === 'number') price = data.variant.price;
      restoreLabel();
      update();
    });

    update();
  }

  // ------------------------------------------------------ metal switcher
  function setupSwitcher(sectionId) {
    var switcher = document.querySelector('[data-be-metal-switcher][data-section="' + sectionId + '"]');
    if (!switcher) return;
    var links = Array.prototype.slice.call(switcher.querySelectorAll('a[data-base-url]'));

    links.forEach(function (a) {
      if (a.getAttribute('aria-current') === 'true') {
        a.addEventListener('click', function (e) {
          e.preventDefault();
        });
      }
    });

    function apply(state) {
      var BE = window.BEEngraving;
      if (!BE || typeof BE.buildUrl !== 'function' || !state) return;
      var carry = {
        front: state.front,
        back: state.back,
        fontValue: state.fontValue,
        align: state.align,
        size: state.size,
        side: state.side,
        tally: state.tally,
        name: state.name,
        heart: state.heart,
        replace: replaceState.key && !replaceState.done ? replaceState.key : '',
      };
      var qtyParam = carry.replace && replaceState.qty ? 'qty=' + replaceState.qty : '';
      links.forEach(function (a) {
        var href = BE.buildUrl(a.dataset.baseUrl, carry);
        if (qtyParam) {
          var h = href.indexOf('#');
          var hash = h === -1 ? '' : href.slice(h);
          var base = h === -1 ? href : href.slice(0, h);
          href = base + (base.indexOf('?') === -1 ? '?' : '&') + qtyParam + hash;
        }
        a.href = href;
      });
    }

    document.addEventListener('engraving:change', function (e) {
      if (e.detail && e.detail.sectionId === sectionId) apply(e.detail);
    });

    var personalizer = document.querySelector('engraving-personalizer[data-section="' + sectionId + '"]');
    if (personalizer && typeof personalizer.getState === 'function') {
      try {
        apply(personalizer.getState());
      } catch (e) {
        /* personalizer not ready yet; its init event will arrive */
      }
    }
  }

  // ------------------------------------------------------ metal variant
  // A "Metal" variant option (Aluminum / Stainless steel, product-variant-picker.liquid): the label,
  // every engraving preview in the section and the Personalize sheet's metal name follow the choice.
  // Runs on the radio change (instant) and again on Dawn's variantChange (any other way in).
  function metalKey(text) {
    var t = String(text || '').toLowerCase();
    if (t.indexOf('alumin') !== -1) return 'aluminum';
    if (t.indexOf('stainless') !== -1 || t.indexOf('steel') !== -1) return 'stainless';
    if (t.indexOf('brass') !== -1) return 'brass';
    if (t.indexOf('copper') !== -1) return 'copper';
    return '';
  }

  function setupVariantMetal(section, sectionId) {
    var fieldset = section.querySelector('[data-be-metal-option]');
    if (!fieldset) return;

    function apply(value) {
      var key = metalKey(value);
      if (!key) return;
      var BE = window.BEEngraving;
      var label = BE && BE.METALS && BE.METALS[key] ? BE.METALS[key].label : value;
      section.querySelectorAll('[data-be-metal-current]').forEach(function (el) {
        el.textContent = value;
      });
      section.querySelectorAll('engraving-preview').forEach(function (pv) {
        if (typeof pv.update === 'function') pv.update({ metal: key });
      });
      section.querySelectorAll('[data-preview-metal-caption]').forEach(function (el) {
        el.textContent = 'Live preview · ' + label;
      });
      var sheet = section.querySelector('be-personalize-sheet');
      if (sheet) {
        sheet.dataset.metalLabel = label;
        if (typeof sheet.sync === 'function' && typeof sheet.getState === 'function') sheet.sync(sheet.getState());
      }
    }

    fieldset.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) apply(e.target.value);
    });

    sub('variantChange', function (event) {
      var data = event && event.data;
      if (!data || data.sectionId !== sectionId || !data.variant) return;
      var options = data.variant.options || [];
      for (var i = 0; i < options.length; i++) {
        if (metalKey(options[i])) {
          apply(options[i]);
          return;
        }
      }
    });
  }

  // ------------------------------------------------------------ gallery
  function setupGallery(section, sectionId) {
    var list = document.getElementById('Slider-Gallery-' + sectionId);
    var dotsWrap = section.querySelector('[data-be-gallery-dots]');

    if (list && dotsWrap) {
      var dots = dotsWrap.children;
      var frame = 0;
      var syncDots = function () {
        frame = 0;
        var width = list.clientWidth || 1;
        var index = Math.round(list.scrollLeft / width);
        index = Math.max(0, Math.min(dots.length - 1, index));
        for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === index);
      };
      list.addEventListener(
        'scroll',
        function () {
          if (!frame) frame = window.requestAnimationFrame(syncDots);
        },
        { passive: true }
      );
    }

    // Dawn moves a variant's featured image to the front of the gallery; put the preview back.
    if (section.querySelector('.be-gallery-preview')) {
      sub('variantChange', function (event) {
        if (!event || !event.data || event.data.sectionId !== sectionId) return;
        document.querySelectorAll('[id^="Slider-Gallery-' + sectionId + '"]').forEach(function (ul) {
          var preview = ul.querySelector(':scope > .be-gallery-preview');
          if (preview && ul.firstElementChild !== preview) ul.insertBefore(preview, ul.firstElementChild);
        });
      });
    }
  }

  // --------------------------------------------------------- review link
  function setupRatingLink(section) {
    section.querySelectorAll('.be-rating a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target =
          (id && document.getElementById(id)) ||
          document.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget, [id^="judgeme_product_reviews"]');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // --------------------------------------------------------------- init
  function initSection(section) {
    if (section._beProductInit) return;
    section._beProductInit = true;
    var sectionId = section.dataset.section;
    if (!sectionId) return;

    setupTotal(sectionId);
    setupSwitcher(sectionId);
    setupVariantMetal(section, sectionId);
    setupGallery(section, sectionId);
    setupRatingLink(section);

    if (replaceState.key && !replaceState.done) {
      showNotice(section);
      applyQty(sectionId);
    }
  }

  function init() {
    if (!replaceState.key) {
      replaceState.key = readReplace();
      if (replaceState.key) replaceState.qty = readQty();
    }
    document.querySelectorAll('[data-be-product][data-section]').forEach(initSection);
  }

  window.BEProductForm = { formatMoney: formatMoney, init: init };

  // DOMContentLoaded fires after every deferred script (pubsub, personalizer, preview) has run.
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('load', init);
  }
})();
